import type { TextFieldProps as AriaTextFieldProps, ValidationResult } from 'react-aria-components';
import { TextField as AriaTextField, Label, Input, FieldError, Text } from 'react-aria-components';



interface TextFieldProps extends Omit<AriaTextFieldProps, 'value'> {
	label?: string;
	value?: string | null | undefined;
	description?: string;
	errorMessage?: string | ((validation: ValidationResult) => string);
}


export function TextField(props: TextFieldProps) {
	const { label, isRequired = false, description, errorMessage, value, ...otherProps } = props;

	return (
		<AriaTextField {...otherProps} isRequired={isRequired} {...(value && { value: value ?? '' })}>
			
			<Label>{label} {isRequired && <span>*</span>}</Label>

			<Input />
			
			{description &&
				<Text slot="description">{description}</Text>
			}
			
			<FieldError>{errorMessage}</FieldError>
		
		</AriaTextField>
	)
}